module.exports = __webpack_public_path__ + "static/media/najcitanejsie-top.f9c061f7.svg";